import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { findIndex, orderBy } from "lodash";
import {
  StyledSelectMenuWithIncrementDecrementWrapper,
  tldrSelectMenuWithIncrementDecrementStyle,
  StyledOptionDecrementButton,
  StyledOptionIncrementButton,
} from "../styled/styleSelectMenuWithIncrementDecrement";
import { connect } from "react-redux";
import { Tooltip } from "@chakra-ui/react";
import { FaMinus, FaPlus } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { CreatableSelect, createFilter } from "chakra-react-select";

const TLDRSelectMenuWithIncrementDecrement = (props) => {
  const { t } = useTranslation(["studio"]);
  const { placeholder, options: initialOptions, rightsidebar } = props;
  let { value: initialValue } = props;

  if (typeof initialValue.value === "object" && initialValue.value.length > 0) {
    initialValue = {
      value: "",
      label: "",
    };
  }

  const [value, setValue] = useState(initialValue);
  const [options, setOptions] = useState(initialOptions);

  const valueIndex = findIndex(options, value);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  function onChange(selectedOption) {
    setValue(selectedOption);
    props.onValueChange(selectedOption.value);
  }

  function increment() {
    const { createOption, onValueChange, step } = props;
    let incrementedValue = createOption(parseFloat(value.label) + step);
    setValue(incrementedValue);
    onValueChange(incrementedValue.value);
  }

  function decrement() {
    const { createOption, onValueChange, step } = props;
    let decrementedValue = createOption(parseFloat(value.label) - step);
    setValue(decrementedValue);
    onValueChange(decrementedValue.value);
  }

  function onCreateOption(inputValue) {
    const { createOption, onValueChange } = props;

    const newOption = createOption(parseFloat(inputValue));
    setOptions(orderBy([...options, newOption], ["label"], ["asc"]));
    setValue(newOption);
    onValueChange(newOption.value);
  }

  return (
    <StyledSelectMenuWithIncrementDecrementWrapper>
      <Tooltip hasArrow placement="bottom" label={t("decrement_tooltip")}>
        <StyledOptionDecrementButton onClick={decrement}>
          <FaMinus />
        </StyledOptionDecrementButton>
      </Tooltip>
      <CreatableSelect
        filterOption={createFilter({
          matchFrom: "any",
          stringify: (option) => `${option.label}`,
        })}
        onChange={onChange}
        onCreateOption={onCreateOption}
        options={options}
        chakraStyles={tldrSelectMenuWithIncrementDecrementStyle}
        placeholder={placeholder}
        isSearchable
        formatCreateLabel={(inputValue) => {
          return parseFloat(inputValue);
        }}
        value={valueIndex > 0 ? options[valueIndex] : value}
        menuPosition={
          props.isMobileView && !rightsidebar.isActionPanelOpen ? "fixed" : ""
        }
      />

      <Tooltip hasArrow placement="bottom" label={t("increase_tooltip")}>
        <StyledOptionIncrementButton onClick={increment}>
          <FaPlus />
        </StyledOptionIncrementButton>
      </Tooltip>
    </StyledSelectMenuWithIncrementDecrementWrapper>
  );
};

TLDRSelectMenuWithIncrementDecrement.propTypes = {
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.object.isRequired,
  onValueChange: PropTypes.func.isRequired,
  createOption: PropTypes.func.isRequired,
  step: PropTypes.number.isRequired,
};

TLDRSelectMenuWithIncrementDecrement.defaultProps = {
  options: [],
  placeholder: "Select",
  step: 1,
  value: {
    value: "",
    label: "",
  },
};

const mapStateToProps = (state) => ({
  rightsidebar: state.rightsidebar,
  isMobileView: state.app.isMobileView,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TLDRSelectMenuWithIncrementDecrement);
